// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='TreeAssetView'] {\n  /* flex: 0 0 240px; */\n  /* max-width: 240px; */\n  /* margin-right: 30px; */\n  /* background: none; */\n  /* overflow: auto; */\n  background: var(--dropdown-bg-selected);\n  border-right: 1px solid var(--separator-color);\n}\n  /* padding-top: 30px; */\n  [name='TreeAssetView'] .folder {\n    color: var(--secondary-font-color);\n    font-size: 12px;\n    padding: 10px;\n    font-weight: 500;\n    padding-left: 20px;\n  }\n", ""]);
// Exports
module.exports = exports;
